"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionButton = exports.Section = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const Button_1 = require("../../components/Button/Button");
const Menu_context_1 = require("../../store/Menu.context");
const Section_styles_1 = require("./Section.styles");
const SectionMapper_1 = require("./SectionMapper");
function Section({ title, id, onOpenChange, onVisibilityChange, onUpdate, data, items, }) {
    const menuDispatch = (0, Menu_context_1.useMenuDispatch)();
    const onOpenSectionClose = (0, react_1.useCallback)((open) => {
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
        onVisibilityChange(open);
        menuDispatch({
            type: 'SET_SECTION',
            payload: {
                isVisible: false,
                name: null,
            },
        });
        menuDispatch({
            type: 'SET_TOOLBAR',
            payload: {
                isToolbarVisible: false,
            },
        });
    }, [onVisibilityChange, menuDispatch, onOpenChange]);
    const theme = (0, ui_common_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Section_styles_1.StyledTitle, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Body", children: title }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: "cross", onClick: () => onOpenSectionClose(false), color: theme.Color.Neutrals.Dark })] }), (0, jsx_runtime_1.jsx)(Section_styles_1.StyledContent, { children: (0, SectionMapper_1.SectionMapper)({
                    items: items,
                    componentId: id,
                    onUpdate: onUpdate,
                    data: data,
                    onSectionClose: onOpenSectionClose,
                }) })] }));
}
exports.Section = Section;
function SectionButton({ icon, title, variant, onUpdate, customToggle, }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: customToggle ? ((0, jsx_runtime_1.jsx)(Section_styles_1.StyledButtonCustom, { onClick: onUpdate, children: customToggle })) : ((0, jsx_runtime_1.jsx)(Button_1.Button, { icon: icon, title: title, variant: variant, onClick: onUpdate })) }));
}
exports.SectionButton = SectionButton;
//# sourceMappingURL=Section.js.map